import { render, staticRenderFns } from "./AgenciaObjetivoDashboard.vue?vue&type=template&id=3bedb92f&scoped=true"
import script from "./AgenciaObjetivoDashboard.vue?vue&type=script&lang=js"
export * from "./AgenciaObjetivoDashboard.vue?vue&type=script&lang=js"
import style0 from "./AgenciaObjetivoDashboard.vue?vue&type=style&index=0&id=3bedb92f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bedb92f",
  null
  
)

export default component.exports